<template>
  <Layout>
    <div class="bloco">
      <header>
        <HeaderPage :page-titles="pageTitles" :hide-button="true" />
        <div class="row-option">
          <b-form-group
            class="col-lg-6 col-md-12"
            label="Obra"
            label-for="input-1"
            :description="
              $store.state.filial && $store.state.filial !== 'false'
                ? descriptionObra
                : 'Para visualizar as estatísticas de uma filial específica, selecione uma filial.'
            "
          >
            <b-form-select
              v-model="obra"
              :options="optionsObrasSelect"
              @change="handleChangeSelectObra"
            />
          </b-form-group>
          <b-form-group
            class="col-lg-6 col-md-12"
            label="Período"
            label-for="input-1"
            :description="'Filtre as estatísticas por um intervalo de datas, máximo de 90 dias.'"
          >
            <div class="w-100">
              <date-picker
                v-model="dateRange"
                format="DD/MM/YYYY"
                range-separator=" - "
                :placeholder="
                  changeRange
                    ? null
                    : String(
                        dateRange[0].split('T')[0].split('-').reverse()
                      ).replaceAll(',', '/') +
                      ' - ' +
                      String(
                        dateRange[1].split('T')[0].split('-').reverse()
                      ).replaceAll(',', '/')
                "
                range
                @change="handleChangeRange"
              />
            </div>
          </b-form-group>
        </div>
        <hr />
      </header>
      <section>
        <div class="row">
          <!-- Requisições -->
          <b-card
            class="col-lg-6 col-md-12"
            title="Total de requisições cadastradas"
          >
            <apexchart
              v-if="optionsRequisicoes.xaxis.categories.length > 0"
              :key="chartKeyRequisicoes"
              class="chart"
              fore-color="#000"
              :series="requisicoesCadastradas"
              :options="optionsRequisicoes"
            />
            <div class="text-width">
              <img
                src="../../../../assets/images/rotate.svg"
                style="height: 120px"
              />
              <p>
                A tela de seu dispositivo é muito pequena para exibir este
                gráfico, tente alternar a orientação do dispositivo para
                horizontal.
              </p>
            </div>
          </b-card>

          <!-- Eficiência de Estoque -->
          <b-card
            class="col-lg-6 col-md-12 no-select"
            title="Eficiência de Estoque"
          >
            <Velocimetro
              :key="keyPercentual"
              :efficiency="porcentagem"
              :loading="isLoading"
              class="chart"
            />
            <div class="text-width">
              <img
                src="../../../../assets/images/rotate.svg"
                style="height: 120px"
              />
              <p>
                A tela de seu dispositivo é muito pequena para exibir este
                gráfico, tente alternar a orientação do dispositivo para
                horizontal.
              </p>
            </div>
          </b-card>
          <b-card class="col-12" title="Movimentos de Estoque">
            <div class="column chart">
              <div class="spam center">
                <p class="center margin-0"> Total Estoque </p>
                <p class="bold margin-0">
                  {{ totalEstoque ? totalEstoque : 'R$ 0,00' }}
                </p>
              </div>
              <div class="spam center">
                <p class="center margin-0"> Total Entrada </p>
                <p class="bold margin-0">
                  {{ totalEntrada ? totalEntrada : 'R$ 0,00' }}
                </p>
              </div>
              <div class="spam center">
                <p class="center margin-0"> Total Saída </p>
                <p class="bold margin-0">
                  {{ exits ? exits : 'R$ 0,00' }}
                </p>
              </div>
            </div>
            <div class="text-width">
              <img
                src="../../../../assets/images/rotate.svg"
                style="height: 120px"
              />
              <p>
                A tela de seu dispositivo é muito pequena para exibir este
                gráfico, tente alternar a orientação do dispositivo para
                horizontal.
              </p>
            </div>
          </b-card>
        </div>
      </section>
    </div>
    <loading-component
      :is-loading="isLoading"
      text="Observação: Os movimentos de estoque podem levar alguns minutos para carregar devido à complexidade das consultas."
    />
  </Layout>
</template>
<script>
import Layout from '@layouts/main'
import HeaderPage from '@/src/components/register/header-page.vue'
import alertMixin from '@/src/mixins/alertMixin'
import 'vue-select/dist/vue-select.css'
import serviceStatistics from '@/src/services/serviceStatistics'
import Velocimetro from '@/src/components/relatorio/velocimetro.vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/pt-br'
import serviceObra from '@/src/services/serviceObra'
import loadingComponent from '@/src/components/loading/loading-component.vue'

export default {
  components: { Layout, HeaderPage, Velocimetro, DatePicker, loadingComponent },
  mixins: [alertMixin],
  data() {
    return {
      changeRange: false,
      keyPercentual: 1,
      porcentagem: 0,
      totalEstoque: 0,
      chartKeyRequisicoes: 0,
      dateRange: [
        new Date(new Date().setDate(new Date().getDate() - 90)).toISOString(),
        new Date().toISOString(),
      ],
      isLoading: false,
      obra: null,
      optionsObrasSelect: [{ value: null, text: 'Todas' }],
      descriptionObra:
        'Ao não selecionar uma obra, serão exibidas as estatísticas referentes a todas as obras da filial.',
      filial: null,
      optionsFiliaisSelect: [{ value: null, text: 'Todas' }],
      descriptionFilial:
        'Selecione uma filial. Ao não selecionar uma filial, serão exibidos os dados correspondentes a todas as filiais que seu usuário tem acesso.',
      nomeEmpresa: '',
      exits: null,
      totalEntrada: null,

      // Variáveis relativas a modais
      showModalFiliais: false,
      showModalObras: false,

      // variáveis relativas a páginação de obras
      currentPageObras: 1,

      // variável relativa aos fields de tabela de obras
      obrasFields: [
        {
          label: 'Nome',
          key: 'nome',
          sortable: true,
        },
        {
          label: 'Empresa',
          key: 'empresa',
          sortable: true,
          thStyle: { width: '22vw' },
        },
        {
          label: 'Filial',
          key: 'filial',
          sortable: true,
          thStyle: { width: '20vw' },
        },
        {
          label: 'Data de Criação',
          key: 'createdAt',
          sortable: true,
          thStyle: { width: '8vw' },
        },
      ],

      // variáveis relativas a páginação de filiais
      currentPageFiliais: 1,

      // variáveis relativas a itens filiais
      filiais: [],

      // variável relativa aos fields de tabela de filiais
      filiaisFields: [
        {
          label: 'Nome',
          key: 'nome',
          sortable: true,
        },
        {
          label: 'Empresa',
          key: 'empresa',
          sortable: true,
          thStyle: { width: '20vw' },
        },
        {
          label: 'Data de Criação',
          key: 'createdAt',
          sortable: true,
          thStyle: { width: '8vw' },
        },
      ],

      // Variáveis relativas ao gráfico de filiais
      optionsFiliais: {
        chart: {
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        yaxis: {
          show: false,
        },
        xaxis: {
          categories: [],
          labels: {
            show: true,
            style: {
              fontSize: '14px',
            },
          },
        },
      },

      // Variáveis relativas ao gráfico de obras
      optionsObras: {
        chart: {
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        yaxis: {
          show: false,
        },
        xaxis: {
          categories: [],
          labels: {
            show: true,
            style: {
              fontSize: '14px',
            },
          },
        },
      },

      // variáveis relativas a itens Requisições
      requisicoes: [],

      // Variáveis relativas ao gráfico de obras
      optionsRequisicoes: {
        chart: {
          type: 'bar',
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        yaxis: {
          show: false,
        },
        xaxis: {
          categories: [],
          labels: {
            show: true,
            style: {
              fontSize: '14px',
            },
          },
        },
      },

      // Variáveis relativa a informações do pageHeader
      pageTitles: {
        title: 'Estatísticas de Eficiência',
        subtitle: 'Estatísticas de eficiência de Filial ou Obra',
      },
    }
  },
  watch: {
    filial(value) {
      this.updateByFiliais()
    },
  },

  async mounted() {
    this.isLoading = true
    await Promise.all([
      this.getObras(),
      this.getRequests(),
      this.getMovimentosEstoque(),
      this.takeExits(),
      this.getStockPeriod(),
    ])
    this.isLoading = false
  },
  methods: {
    async takeExits() {
      this.exits = 'Carregando...'

      if (!this.dateRange) {
        return
      }

      try {
        const response = await serviceStatistics.getExits(
          this.obra,
          this.$store.state.filial,
          this.dateRange ? `${this.dateRange[0]}` : null,
          this.dateRange ? `${this.dateRange[1]}` : null
        )

        this.exits = response.data.data.totalSaida
        if (
          this.totalEntrada !== 'Carregando...' &&
          this.totalEntrada !== null
        ) {
          this.porcentagem = Number(
            (Number(
              String(this.exits ? this.exits : 'R$ 0000.00')
                .replace('R$', '')
                .replaceAll('.', '')
                .replace(',', '')
                .trim()
            ) /
              Number(
                String(this.totalEntrada ? this.totalEntrada : 'R$ 0000.00')
                  .replace('R$', '')
                  .replaceAll('.', '')
                  .replace(',', '')
                  .trim()
              )) *
              100
          ).toFixed(2)

          if (this.porcentagem === 'NaN') {
            this.porcentagem = 0
          } else if (this.porcentagem === 'Infinity') {
            this.porcentagem = 100
          }

          this.keyPercentual = Number(this.keyPercentual) + 1
        }
      } catch (e) {
        this.isLoading = false

        console.error(e)
        this.$bvToast.toast(
          'Ocorreu um erro ao carregar os dados de saídas, tente novamente.',
          {
            variant: 'danger',
            autoHideDelay: 5000,
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
      }
    },
    async getMovimentosEstoque() {
      this.totalEstoque = 'Carregando...'

      if (!this.dateRange) {
        return
      }

      try {
        const response = await serviceStatistics.getMovements(
          this.obra,
          this.$store.state.filial,
          null,
          this.dateRange ? `${this.dateRange[1]}` : null
        )

        this.totalEstoque = response.data.data
      } catch (e) {
        this.isLoading = false

        console.error(e)
        this.$bvToast.toast(
          'Ocorreu um erro ao carregar os dados de movimentos de estoque, tente novamente.',
          {
            variant: 'danger',
            autoHideDelay: 5000,
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
      }
    },

    // Função relativa a recarregar os dados
    async updateByFiliais() {
      this.isLoading = true
      this.currentPageObras = 1
      this.currentPageFiliais = 1

      this.optionsFiliais.series = []
      this.optionsObras.series = []
      this.obra = null

      await Promise.all([
        this.getObras(),
        this.getRequests(),
        this.getMovimentosEstoque(),
        this.takeExits(),
        this.getStockPeriod(),
      ])
      this.isLoading = false
    },

    // Função para obter as obras
    async getObras() {
      this.optionsObrasSelect = [{ value: null, text: 'Todas' }]
      const filial = this.$store.state.filial

      let data = { data: [] }

      if (filial) {
        let res = await serviceObra.list('filial', filial)

        data = res.data
      } else {
        let res = await serviceObra.list()

        data = res.data
      }

      data = data.data

      if (data.length === 0) {
        this.$bvToast.toast(
          'Não há obras cadastradas para a filial selecionada.',
          {
            variant: 'warning',
            autoHideDelay: 5000,
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
        this.optionsObrasSelect = [
          {
            value: null,
            text: 'Não há obras cadastradas para a filial selecionada',
          },
        ]
      }

      this.optionsObrasSelect = [{ value: null, text: 'Todas' }]

      data.map((obra) => {
        this.optionsObrasSelect.push({
          value: obra._id,
          text: obra.nome,
        })
      })
    },

    async getStockPeriod() {
      this.totalEntrada = 'Carregando...'

      if (!this.dateRange) {
        return
      }

      try {
        let res = await serviceStatistics.getStockPeriod(
          this.obra,
          this.$store.state.filial,
          this.dateRange ? `${this.dateRange[0]}` : null,
          this.dateRange ? `${this.dateRange[1]}` : null
        )

        this.totalEntrada = res.data
        console.log(this.totalEntrada)
        if (this.exits !== 'Carregando...' && this.exits !== null) {
          this.porcentagem = Number(
            (Number(
              String(this.exits ? this.exits : 'R$ 0000.00')
                .replace('R$', '')
                .replaceAll('.', '')
                .replace(',', '')
                .trim()
            ) /
              Number(
                String(this.totalEntrada ? this.totalEntrada : 'R$ 0000.00')
                  .replace('R$', '')
                  .replaceAll('.', '')
                  .replace(',', '')
                  .trim()
              )) *
              100
          ).toFixed(2)

          if (this.porcentagem === 'NaN') {
            this.porcentagem = 0
          } else if (this.porcentagem === 'Infinity') {
            this.porcentagem = 100
          }

          this.keyPercentual = Number(this.keyPercentual) + 1
        }
      } catch (error) {
        this.isLoading = false

        this.errorMessage(
          'Ocorreu um erro ao carregar os dados de movimentos de estoque, tente novamente.',
          'danger'
        )
      }
    },

    // Função relativa ao select de obra
    async handleChangeSelectObra() {
      this.isLoading = true

      await Promise.all([
        this.getRequests(),
        this.getMovimentosEstoque(),
        this.takeExits(),
        this.getStockPeriod(),
      ])

      this.isLoading = false
    },

    // Função relativa ao input de range
    async handleChangeRange() {
      if (!this.dateRange || this.dateRange.length === 0) {
        this.errorMessage('Selecione um intervalo de datas.', 'warning')

        return
      }

      this.changeRange = true

      this.isLoading = true
      await Promise.all([
        this.getRequests(),
        this.getMovimentosEstoque(),
        this.takeExits(),
        this.getStockPeriod(),
      ])

      this.isLoading = false
    },

    // Função relativa ao gráfico de requisições
    async getRequests() {
      if (!this.dateRange) {
        return
      }

      if (this.dateRange) {
        if (this.dateRange.length > 0) {
          const date1 = new Date(this.dateRange[0])
          const date2 = new Date(this.dateRange[1])
          const diffTime = Math.abs(date2 - date1)
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

          if (diffDays > 91) {
            this.errorMessage(
              'O intervalo de datas não pode ultrapassar 90 dias.',
              'danger'
            )

            this.isLoading = false

            return
          }
        }
      }

      if (this.dateRange) {
        this.dateRange = this.dateRange.sort((a, b) => {
          return new Date(a) - new Date(b)
        })
      }

      try {
        const response = await serviceStatistics.getRequests(
          false,
          this.$store.state.filial,
          this.obra,
          this.dateRange ? `${this.dateRange[0]} - ${this.dateRange[1]}` : null
        )
        let requests = response.data
        let data = {
          series: [
            {
              name: 'Concluídas',
              foreColor: '#000',
              data: [],
            },
            {
              name: 'Pendentes',
              foreColor: '#000',
              data: [],
            },
          ],
        }

        this.optionsRequisicoes.xaxis.categories = []

        for (const mes in requests.historic) {
          this.optionsRequisicoes.xaxis.categories.push(mes)
          data.series[0].data.push(requests.historic[mes].concluido)
          data.series[1].data.push(requests.historic[mes].pendente)
        }

        this.requisicoesCadastradas = data.series
        this.chartKeyRequisicoes = this.chartKeyRequisicoes + 1
      } catch (e) {
        this.isLoading = false

        console.error(e)
        this.$bvToast.toast(
          'Ocorreu um erro ao carregar os dados de obras, tente novamente.',
          {
            variant: 'danger',
            autoHideDelay: 5000,
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
      }
    },
  },
}
</script>

<style>
.middle {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  gap: 20px;
}

.spam {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #ececec;
  border-radius: 10px;
  padding: 15px;
  margin-top: 25px;
  margin-bottom: 15px;
}

.margin-0 {
  margin: 0;
}

.no-select {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

.row-option {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}

.button-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  gap: 10px;
  height: 150px;
  width: 150px;
  cursor: pointer;
}

.button-box:hover {
  background-color: rgb(0 143 251);
  color: #fff;
  transition: all 0.3s ease-in-out;
}

.container-buttons {
  display: flex;
  height: 85%;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
  gap: 10px;
}

.container-pagination {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.chart {
  display: block;
}

.text-width {
  display: none;
}

.mx-datepicker-range {
  width: 100%;
}

.mx-input {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 1rem + 2px);
  font-size: 0.875rem;
  font-weight: 400;
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 2.75rem 0.5rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #4b4b5a;
  vertical-align: middle;
  border: 1px solid #e2e7f1;
  border-radius: 0.3rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  box-shadow: none;
}

.mx-input:hover {
  border: 1px solid #e2e7f1;
}

.mx-input:focus {
  border-color: #4b4b5a;
}

@media (max-width: 465px) {
  .chart {
    display: none;
  }

  .text-width {
    display: flex;
    flex-direction: column;
    text-align: justify;
    font-weight: bold;
    gap: 30px;
    margin-top: 25px;
  }

  .text-width img {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .no-select {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
  }
}

@media (max-width: 1300px) {
  .row-option {
    flex-direction: column;
  }

  .no-select {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
  }
}
</style>


<style src="../style.scss" lang="scss"></style>
